// /platform/orders — cross-tenant заказы для PLATFORM_ADMIN (PA-13 / D17 §2.3).
//
// Тонкий wrapper над `OrdersScreen` — backend `/api/orders` уже cross-tenant
// для PA (PA-11): возвращает заказы всех тенантов + обогащает каждый
// distributorId/slug/displayName. Сам экран уже различает PA/non-PA
// (показывает колонку «Дистрибьютор» + distributor-фильтр-селект), поэтому
// re-use 1:1 без копирования.
//
// `navKey='platform-orders'` — пробрасываем, чтобы в sidebar'е PA подсветился
// правильный пункт. Без этого экран ставит default `'orders'`, а у PA в
// меню такого пункта нет (distributor-only) — подсветка терялась.
//
// Route-level guard `redirectIfNotPlatformAdmin` — distributor-scoped
// пользователь, заглянувший на `/platform/orders` руками, редиректится на
// /dashboard. Дополнительная проверка permission `platform.orders.view-all`
// уже сидит в `OrdersScreen.canView` (через PERMISSION_VIEW_ANY).

import { createFileRoute, redirect } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { RetiredScreen } from '../components/RetiredScreen'
import { redirectIfNotPlatformAdmin } from '../lib/platformAdminGuard'

export const Route = createFileRoute('/platform/orders')({
  beforeLoad: () => {
    redirectIfNotPlatformAdmin(redirect)
  },
  component: PlatformOrdersRoute,
})

function PlatformOrdersRoute() {
  return (
    <RequireAuth>
      <RetiredScreen />
    </RequireAuth>
  )
}
